import React from "react";
import { Box } from "@mui/material";
import { colors, fonts } from "../../theme/tokens";

const ServicesHero = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        pt: { xs: "118px", md: "148px" },
        pb: "64px",
        px: { xs: "20px", md: "28px" },
        "@keyframes heroUp": {
          from: { transform: "translateY(26px)", opacity: 0 },
          to: { transform: "translateY(0)", opacity: 1 },
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-120px",
          left: "-100px",
          width: "480px",
          height: "480px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle,rgba(246,166,35,.16),transparent 65%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "relative",
          maxWidth: "920px",
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            animation: "heroUp .6s both",
          }}
        >
          <Box
            sx={{ width: "26px", height: "2px", background: colors.amber }}
          />
          <Box
            sx={{
              fontFamily: fonts.display,
              fontSize: "12.5px",
              fontWeight: 600,
              letterSpacing: ".2em",
              color: colors.steelBlue,
            }}
          >
            OUR SERVICES
          </Box>
          <Box
            sx={{ width: "26px", height: "2px", background: colors.amber }}
          />
        </Box>
        <Box
          component="h1"
          sx={{
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: "clamp(34px,5vw,60px)",
            lineHeight: 1.05,
            letterSpacing: "-.02em",
            color: colors.navyInk,
            mt: "22px",
            mb: 0,
            animation: "heroUp .7s .06s both",
          }}
        >
          Expert solutions tailored for your success
        </Box>
        <Box
          sx={{
            fontFamily: fonts.body,
            fontSize: "18px",
            lineHeight: 1.65,
            color: colors.mutedText,
            maxWidth: "700px",
            mx: "auto",
            mt: "24px",
            animation: "heroUp .8s .14s both",
          }}
        >
          A full range of specialised services designed to support your business
          at every stage, from strategy and finance to technology and property
          advisory.
        </Box>
      </Box>
    </Box>
  );
};

export default ServicesHero;
